import * as actionTypes from '../actionTypes';

const initialState = {
  lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'bg',
  medicineSearchLetter: '',
  medicineSearchName: '',
  isUserLogged: false,
  isUserJustLogged: false,
  isNotificationUpdated: false,
  medicineSearchActiveIngredient: ''
}

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LANG_CHANGE:
      return {
        ...state,
        lang: action.lang
      }
    case actionTypes.MEDICINE_SEARCH_BY_LETTER:
      return {
        ...state,
        medicineSearchLetter: action.medicineSearchLetter
      }
    case actionTypes.MEDICINE_SEARCH_BY_NAME:
      return {
        ...state,
        medicineSearchName: action.medicineSearchName
      }
    case actionTypes.USER_LOGIN:
      return {
        ...state,
        isUserLogged: true,
        isUserJustLogged: true
      }
    case actionTypes.SET_USER_JUST_LOGGED_TO_FALSE:
      return {
        ...state,
        isUserJustLogged: false
      }
    case actionTypes.USER_LOGOUT:
      return {
        ...state,
        isUserLogged: false
      }
    case actionTypes.SET_USER_NOTIFICATIONS:
      return {
        ...state,
        isNotificationUpdated: false
      }
    case actionTypes.NOTIFICATION_ADDED:
      return {
        ...state,
        isNotificationUpdated: true
      }

    case actionTypes.MEDICINE_SEARCH_BY_ACTIVE_INGREDIENT:
      return {
        ...state,
        medicineSearchActiveIngredient: action.medicineSearchActiveIngredient
      }
  }

  return state;
}

export default commonReducer;